export const YEU_CAU_SUA_CHUA_PERMISSION_CODES = {
  WEB_BH_YEU_CAU_SUA_CHUA_LIST: 'WEB_BH_YEU_CAU_SUA_CHUA_LIST',
  WEB_BH_YEU_CAU_SUA_CHUA_DETAIL: 'WEB_BH_YEU_CAU_SUA_CHUA_DETAIL',
  WEB_BH_YEU_CAU_SUA_CHUA_ADD: 'WEB_BH_YEU_CAU_SUA_CHUA_ADD',
  WEB_BH_YEU_CAU_SUA_CHUA_EDIT: 'WEB_BH_YEU_CAU_SUA_CHUA_EDIT',
  WEB_BH_YEU_CAU_SUA_CHUA_CANCEL: 'WEB_BH_YEU_CAU_SUA_CHUA_CANCEL',
  WEB_BH_YEU_CAU_SUA_CHUA_COMPLETE: 'WEB_BH_YEU_CAU_SUA_CHUA_COMPLETE',
  WEB_BH_YEU_CAU_SUA_CHUA_PROCESS: 'WEB_BH_YEU_CAU_SUA_CHUA_PROCESS',
  WEB_BH_YEU_CAU_SUA_CHUA_EXPORT: 'WEB_BH_YEU_CAU_SUA_CHUA_EXPORT',
} as const

export const YEU_CAU_SUA_CHUA_MUTATE_PERMISSIONS = [
  YEU_CAU_SUA_CHUA_PERMISSION_CODES.WEB_BH_YEU_CAU_SUA_CHUA_ADD,
  YEU_CAU_SUA_CHUA_PERMISSION_CODES.WEB_BH_YEU_CAU_SUA_CHUA_EDIT,
  YEU_CAU_SUA_CHUA_PERMISSION_CODES.WEB_BH_YEU_CAU_SUA_CHUA_CANCEL,
  YEU_CAU_SUA_CHUA_PERMISSION_CODES.WEB_BH_YEU_CAU_SUA_CHUA_COMPLETE,
  YEU_CAU_SUA_CHUA_PERMISSION_CODES.WEB_BH_YEU_CAU_SUA_CHUA_PROCESS,
  YEU_CAU_SUA_CHUA_PERMISSION_CODES.WEB_BH_YEU_CAU_SUA_CHUA_EXPORT,
] as const
